import { useRef } from "react";
import CommonReportActionHeader from "../CommonReport/CommonReportActionHeader";
import { StyledReportContainer } from "../CommonReport/styles";
import CustomModal from "../CustomModal";
import exportComponentAsPDF from "@/util/export_file";

const CellSuggestionPopup = ({
  showCellSuggestion,
  setShowCellSuggestion,
  data,
  setData,
}) => {
  const cellSuggestionRef = useRef();

  return (
    <CustomModal
      show={showCellSuggestion}
      hideSavebutton
      onHide={() => {
        setShowCellSuggestion(false);
        setData([]);
      }}
      size="xl"
    >
      <CommonReportActionHeader
        onClose={() => {
          setShowCellSuggestion(false);
          setData([]);
        }}
        onExportClick={() => {
          exportComponentAsPDF(cellSuggestionRef, "cell-suggestion.pdf");
        }}
      />
      <StyledReportContainer ref={cellSuggestionRef}>
        <table className="table-default">
          <thead>
            <tr>
              <th>Last Name</th>
              <th>First Name</th>
              <th>Middle Name</th>
              <th>Arrest Date</th>
              <th>Housing Assignment Block</th>
              <th>Housing Assignment Cell</th>
              <th>Housing Assignment Bed</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((cellData) => (
              <tr>
                <td>{cellData?.lname}</td>
                <td>{cellData?.fname}</td>
                <td>{cellData?.mname}</td>
                <td>{cellData?.arrestDate}</td>
                <td>{cellData?.block}</td>
                <td>{cellData?.cell}</td>
                <td>{cellData?.bed}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="table-total-row">
          Total Number of Rows: {data?.length}
        </div>
      </StyledReportContainer>
    </CustomModal>
  );
};

export default CellSuggestionPopup;
